import { render, staticRenderFns } from "./TableDefault.vue?vue&type=template&id=5d29b8e7"
import script from "./TableDefault.vue?vue&type=script&lang=js"
export * from "./TableDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../usr/local/share/.config/yarn/global/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports